import TabTriggerLoading from "@/common/components/Tabs/components/TabTriggerLoading";
import { Tabs } from "@/common/components/ui/tabs";
import { tabsDefaultWithFlexGrowClassName } from "@/common/constants/tabsDefaultClassName.constant";
import { useGetCurrentTab } from "@/common/hooks/useGetCurrentTab";
import { useParams } from "react-router-dom";
import MaintenanceWorkflowForwardingShowLoading from "./tabs/ForwardingsTab/MaintenanceWorkflowForwardingShowLoading";
import MaintenanceDescription from "./tabs/MaintenanceDescription";

const MaintenanceWorkflowLoading = () => {
  const { companyId, id } = useParams();

  const currentTab = useGetCurrentTab(`/companies/${companyId}/maintenance/workflows/${id}`);

  return (
    <div className="flex flex-col gap-6">
      <Tabs>
        <TabTriggerLoading
          {...tabsDefaultWithFlexGrowClassName}
          skeletonsCount={2}
        />
      </Tabs>

      {currentTab && <MaintenanceWorkflowForwardingShowLoading />}
      {!currentTab && <MaintenanceDescription workflow={undefined} />}
    </div>
  )
}

export default MaintenanceWorkflowLoading;
